import { isDevelopment } from '../env';
import { joinParameters } from '../uri';

const host = isDevelopment ? 'http://192.168.100.160:8440' : window.location.protocol + '//' + window.location.host;

// 打开会议纪要
export const openSummary = (options: { roomId: string; roomSid: string }) => {
  const href = joinParameters(
    `${host}/summary/www/index.html?v=${new Date().getTime()}#/?refId=${options.roomId}&roomSid=${options.roomSid}`,
  );

  window.open(href);
};

// 打开会议加入链接
export const openJoinroomUrl = (options: { roomId?: string } = {}) => {
  const roomId = options.roomId ?? '';
  const href = joinParameters(`${host}/connect/meeting/joinroom`, {
    meetType: 'video',
    from: 'pc',
    ...(roomId ? { roomId } : {}),
    showSchema: 0,
  });

  window.open(href);
};

// 打开快速会议链接
export const openQuickRoomUrl = () => {
  const href = joinParameters(`${host}/connect/meeting/create`, { showSchema: 0 });

  window.open(href);
};
